import { Controller } from "@hotwired/stimulus"
import { buildAuthToastElement } from "../auth_toast_dom"

// react-toastify-style toasts: top-right, colored progress bar, auto-dismiss (5s), pause on hover.
export default class extends Controller {
  static targets = ["toast"]
  static values = { dismissAfter: { type: Number, default: 5000 } }

  connect() {
    this.toastTargets.forEach((toast) => this.activateToast(toast))

    this.onToast = (event) => {
      const { message, messageType } = event.detail || {}
      this.show(message, messageType)
    }
    document.addEventListener("auth:toast", this.onToast)
  }

  disconnect() {
    document.removeEventListener("auth:toast", this.onToast)
    this.toastTargets.forEach((toast) => this.clearToastTimers(toast))
  }

  show(message, messageType = "error") {
    const messages = Array.isArray(message) ? message : [message]
    messages
      .filter(Boolean)
      .forEach((text) => {
        if (this.hasDuplicateToast(text)) return

        const toast = buildAuthToastElement(
          text,
          messageType,
          this.dismissAfterValue,
        )
        this.element.appendChild(toast)
        this.activateToast(toast)
      })
  }

  hasDuplicateToast(text) {
    const normalized = text.toString().trim()
    return [...this.element.querySelectorAll(".auth-toast")].some((toast) => {
      if (toast.dataset.authToastExiting === "true") return false
      const content = toast.querySelector(".auth-toast__content")
      return content?.textContent?.trim() === normalized
    })
  }

  activateToast(toast) {
    if (toast.dataset.authToastActive === "true") return
    toast.dataset.authToastActive = "true"

    const duration = this.dismissAfterValue
    toast.style.setProperty("--auth-toast-duration", `${duration}ms`)

    const progress = toast.querySelector(".auth-toast__progress-bar")
    const closeBtn = toast.querySelector("[data-auth-toast-close]")

    closeBtn?.addEventListener("click", () => this.dismissToast(toast))

    if (progress) {
      progress.addEventListener(
        "animationend",
        () => this.dismissToast(toast),
        { once: true },
      )
    } else {
      toast._fallbackTimer = window.setTimeout(
        () => this.dismissToast(toast),
        duration,
      )
    }
  }

  dismissToast(toast) {
    if (!toast || toast.dataset.authToastExiting === "true") return
    toast.dataset.authToastExiting = "true"
    this.clearToastTimers(toast)
    toast.classList.add("auth-toast--exiting")
    window.setTimeout(() => toast.remove(), 200)
  }

  clearToastTimers(toast) {
    if (toast._fallbackTimer) {
      window.clearTimeout(toast._fallbackTimer)
      toast._fallbackTimer = null
    }
  }
}
